var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticlesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5511C20 10.1949 20.5388 8.89424 21.4978 7.93525C22.4567 6.97626 23.7574 6.4375 25.1136 6.4375H35.3409C35.68 6.4375 36.0051 6.57219 36.2449 6.81194C36.4846 7.05169 36.6193 7.37685 36.6193 7.71591V28.1705C36.6193 28.5095 36.4846 28.8347 36.2449 29.0744C36.0051 29.3142 35.68 29.4489 35.3409 29.4489H25.1136C23.7574 29.4489 22.4567 29.9876 21.4978 30.9466C20.5388 31.9056 20 33.2063 20 34.5625",
    fill: "#90CAF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5511C20 10.1949 20.5388 8.89424 21.4978 7.93525C22.4567 6.97626 23.7574 6.4375 25.1136 6.4375H35.3409C35.68 6.4375 36.0051 6.57219 36.2449 6.81194C36.4846 7.05169 36.6193 7.37685 36.6193 7.71591V28.1705C36.6193 28.5095 36.4846 28.8347 36.2449 29.0744C36.0051 29.3142 35.68 29.4489 35.3409 29.4489H25.1136C23.7574 29.4489 22.4567 29.9876 21.4978 30.9466C20.5388 31.9056 20 33.2063 20 34.5625",
    stroke: "#90CAF4",
    strokeWidth: 3.07263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38525 28.1705C3.38525 28.5095 3.51994 28.8347 3.75969 29.0744C3.99944 29.3142 4.32461 29.4489 4.66366 29.4489H14.8909C16.2472 29.4489 17.5478 29.9876 18.5068 30.9466C19.4658 31.9056 20.0046 33.2063 20.0046 34.5625V11.5511C20.0046 10.1949 19.4658 8.89424 18.5068 7.93525C17.5478 6.97626 16.2472 6.4375 14.8909 6.4375H4.66366C4.32461 6.4375 3.99944 6.57219 3.75969 6.81194C3.51994 7.05169 3.38525 7.37685 3.38525 7.71591V28.1705Z",
    fill: "#90CAF4",
    stroke: "#90CAF4",
    strokeWidth: 3.07263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78271 14.9141H14.928",
    stroke: "#2B6CB0",
    strokeWidth: 3.07263,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78271 20.0352H12.8795",
    stroke: "#2B6CB0",
    strokeWidth: 3.07263,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.0625L20 35.1875",
    stroke: "#2B6CB0",
    strokeWidth: 2.04842,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlesIcon);
export default __webpack_public_path__ + "static/media/articlesIcon.4e497668bff0640251c6ff376a142c0b.svg";
export { ForwardRef as ReactComponent };